<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('addEditFournisseurs.competences.popupAdd.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns">
        <parametre-autocomplete
          v-model="competence.competenceFournisseurId"
          @select="competence.competenceFournisseur = $event"
          :label="$t('addEditFournisseurs.competences.popupAdd.competenceFournisseur')"
          :target="constantes.PARAMETRES_KEYS.competenceFournisseur"
          :query="queryCompetenceFournisseur"
          class="column"
        />
      </div>
      <footer class="is-flex">
        <button class="button boutonAction" @click="$parent.close()">
          {{ $t('general.button.cancel')}}
        </button>
        <button
          class="button boutonAction is-addOrEdit"
          @click="save()"
          :disabled="!competence.competenceFournisseurId">
          {{ $t('general.button.sauvegarder') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import genererCompetenceFournisseur from '@/services/achat/fournisseurs/genererCompetenceFournisseur';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export default {
  name: 'PAddCompetence',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
  },
  components: {
    ParametreAutocomplete,
  },
  data() {
    return {
      competence: genererCompetenceFournisseur(),
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  methods: {
    save() {
      this.fournisseur.competencesFournisseur.push(this.competence);
      this.$parent.close();
    },
    queryCompetenceFournisseur(item) {
      return !this.fournisseur.competencesFournisseur
        .some(el => el.competenceFournisseurId === item.id);
    },
  },
};
</script>
